export enum ConfigureSidebarModes {
  newFolder,
  showFolder,
  editFolder,
  newLink,
  showLink,
  editLink,
}
